import { Injectable } from "@angular/core";
import { forkJoin, Observable, Subject } from "rxjs";
import { concatMap, tap } from "rxjs/operators";
import { FeatureFlagService } from "./feature-flag/feature-flag.service";
import { MarksStateService } from "./mark-state/marks-state.service";
import { TenantConfigService } from "./http-api/tenant-config.service";
import { TitlesStateService } from "./title-state/titles-state.service";
import { UsersStateService } from "./user-state/users-state.service";
import LiveAssetsStateService from "./live-assets-state.service";

@Injectable({
  providedIn: "root"
})
export class AppBootstrapService {
  private postAgreementBootstrapSubject = new Subject<void>();
  public postAgreementBootstrapCompleted$ = this.postAgreementBootstrapSubject.asObservable();

  constructor(
    private featureFlagService: FeatureFlagService,
    private marksService: MarksStateService,
    private tenantConfigService: TenantConfigService,
    private titlesStateService: TitlesStateService,
    private usersService: UsersStateService,
    private liveAssetService: LiveAssetsStateService
  ) {}

  runPostAgreementBootstrap(): Observable<unknown> {
    return this.featureFlagService.fetchAndUpdate().pipe(
      concatMap(() =>
        forkJoin([
          this.usersService.fetchAndUpdate(),
          this.marksService.fetchAndUpdate(),
          this.titlesStateService.fetchAndUpdate(),
          this.tenantConfigService.fetchAndUpdate(),
          this.liveAssetService.init()
        ])
      ),
      tap(() => this.postAgreementBootstrapSubject.next())
    );
  }
}
